















































































































import { defineComponent, PropType, reactive, computed } from '@vue/composition-api';
import Modal from '@/components/lib/Modal.vue';
import type { ReportRouteSlim } from '@/models/runCourse';
import { dtFormat } from '@/lib/dateHelper';

export default defineComponent({
  components: {
    Modal,
  },
  props: {
    isNewRoute: {
      type: Boolean,
      required: true,
    },
    routeType: {
      type: String,
      required: true,
    },
    editingRoute: {
      type: Object as PropType<ReportRouteSlim>,
      required: true,
    },
    kpRouteMap: {
      type: Object as PropType<{[key:string]: ({[key:string]: string} | undefined)}>,
      required: true,
    },
    routeOptions: {
      type: Object as PropType<{[key:string]: string}>,
      required: true,
    },
  },
  emits: ['save-route', 'add-route', 'start-delete-route', 'cancel-edit'],
  setup(props, { emit }) {
    const state = reactive({
      isNewRoute: props.isNewRoute,
      routeType: props.routeType,
      editingRoute: { ...props.editingRoute },
      kpRouteMap: props.kpRouteMap,
      routeOptions: { ...props.routeOptions },
      showDeleteConfirmation: false,
    });

    const deleteConfirmMessage = computed((): string => {
      const routeName = state.editingRoute.startRoadNameDisp
        .replace(/on/, '(入口)')
        .replace(/off/, '(出口)');
      return `${routeName}[${state.editingRoute.startTs}]の経路を削除します。よろしいですか？`;
    });

    const isCloseButtonDisabled = computed(() => {
      return state.editingRoute && (!state.editingRoute.startRoadNameDisp || !state.editingRoute.startTs);
    });

    const onRouteTypeChange = () => {
      state.routeOptions = {};
      state.editingRoute.startRoadNameDisp = '';
      if (state.routeType && state.kpRouteMap) {
        state.routeOptions = state.kpRouteMap[state.routeType] ?? {};
      }
    };

    const startTsScope = computed({
      get: () => {
        return dtFormat(state.editingRoute.startTs, 'HH:MM');
      },
      set: (val: string) => {
        const now = state.editingRoute.startTs ? new Date(state.editingRoute.startTs) : new Date();
        const [hours, minutes] = val.split(':');
        const newDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(hours), parseInt(minutes), 0);
        state.editingRoute.startTs = dtFormat(newDate, 'yyyy/mm/dd HH:MM:SS');
      },
    });

    const saveRoute = () => {
      emit('save-route', { ...state.editingRoute });
    };

    const addRoute = () => {
      emit('add-route', { ...state.editingRoute });
    };

    const startDeleteConfirm = () => {
      state.showDeleteConfirmation = true;
    };

    const cancelDeleteConfirm = () => {
      state.showDeleteConfirmation = false;
    };

    const confirmDeleteRoute = () => {
      state.showDeleteConfirmation = false;
      emit('start-delete-route');
    };

    const cancelEdit = () => {
      emit('cancel-edit');
    };

    return {
      state,
      deleteConfirmMessage,
      isCloseButtonDisabled,
      startTsScope,
      onRouteTypeChange,
      saveRoute,
      addRoute,
      startDeleteConfirm,
      cancelDeleteConfirm,
      confirmDeleteRoute,
      cancelEdit,
    };
  },
});
